import { render, staticRenderFns } from "./ItemDetailComponent.vue?vue&type=template&id=35e1cc5c&scoped=true"
import script from "./ItemDetailComponent.vue?vue&type=script&lang=js"
export * from "./ItemDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1cc5c",
  null
  
)

export default component.exports